import {withRouter} from 'react-router-dom';
import {List} from "antd";
import VirtualList from "rc-virtual-list";
import {CheckOutlined} from "@ant-design/icons";
import EventDispatcher from "../../events";
import {LoadManageMerchantEvent} from "../../events/LoadManageMerchantEvent";
import {ChangeCurrentMerchantEvent} from "../../events/ChangeCurrentMerchantEvent";
import {HIDE_CHANGE_MERCHANT_POPUP} from "../../config/event";

const ListItem = List.Item;
const ContainerHeight = 250;
let rendered = false;
let hide = null;
const MerchantManager = (props) => {
    if (!props.isVisible) {
        return '';
    }

    if (!hide) {
        hide = () => {
            props.hide();
        };
    }
    EventDispatcher.listener(HIDE_CHANGE_MERCHANT_POPUP, hide);
    if (!rendered) {
        EventDispatcher.dispatch(new LoadManageMerchantEvent());
    }
    rendered = true;
    let {merchant} = props;
    let {merchantId, merchants} = merchant;
    const justifyContent = {justifyContent: 'center'};
    const itemStyle = {textAlign: 'center', margin: '0 auto'};

    return (
        <div className='idChange'>
            <div className='hide' onClick={hide}/>
            <div className='idBox'>
                <div className='title flex' style={justifyContent}>
                    请点击切换商户
                </div>
                <List>
                    <VirtualList
                        data={merchants}
                        height={ContainerHeight}
                        itemHeight={0}
                        itemKey="merchantId"
                        onScroll={(e) => {
                        }}
                    >
                        {(item, index) => (
                            <ListItem key={item.merchantId}>
                                <div onClick={async () => {
                                    EventDispatcher.dispatch(new ChangeCurrentMerchantEvent({
                                        merchant_id: item.merchantId,
                                    }));
                                }}
                                     className={item.merchantId === merchantId ? 'select_active consignor_user_info' : 'consignor_user_info'}>
                                    <div className='limit70 limit mgb10'
                                         style={itemStyle}>
                                        <img className='avatar-image' src={item['avatar']}
                                             alt={item.name}/>

                                    </div>
                                    <p>{item.name}</p>
                                    <CheckOutlined className='select_icon'/>
                                </div>
                            </ListItem>
                        )}
                    </VirtualList>
                </List>
                <ul className='flex contrlBtn'>
                    <li onClick={() => {
                        hide()
                    }}>取消
                    </li>
                </ul>

            </div>
        </div>
    );
}

export default withRouter(MerchantManager);